var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"required-vote"},[_c('p',[_vm._v("This motion requires "),_c('strong',[_vm._v(_vm._s(_vm.requiredText))]),_vm._v(" to pass")])])
}
var staticRenderFns = []

export { render, staticRenderFns }